import React, { useState } from "react";

type JerseyProps = {
	className?: string;
	jerseyTypeAbrv?: string;
	opponentJerseyType?: string;
};

export default function JerseyIcon(props: JerseyProps) {
	const { className, jerseyTypeAbrv, opponentJerseyType } = props;

	const [imageError, setImageError] = useState<boolean>(false);

	if ((!jerseyTypeAbrv && opponentJerseyType) || imageError) {
		return <span className={className ? className : "u-icon--med"}></span>;
	}

	if ((!jerseyTypeAbrv && !opponentJerseyType) || imageError) {
		return null;
	}

	return (
		<img
			className={className ? className : "u-icon--med"}
			//@ts-expect-error
			loading="lazy"
			src={getJerseyIconUrl(jerseyTypeAbrv)}
			onError={() => {
				setImageError(true);
			}}
		/>
	);
}

function getJerseyIconUrl(jerseyTypeAbrv: string | undefined) {
	return `${WEBPACK_CDN_ROOT_URL}/icons/jerseys/${jerseyTypeAbrv?.toLowerCase()}.svg`;
}
